import type { RouteObject } from "react-router-dom";

export const marketRateCalculationRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Market rate calculation" },
    async lazy() {
      const { Page } = await import("../../app/page");
      return {
        element: (
          <Page
            hidePadding={(_url, search) =>
              search?.includes("tab=international") ?? false
            }
          />
        ),
      };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { MarketRateCalculation } =
            await import("./market-rate-calculation");
          return { Component: MarketRateCalculation };
        },
      },
      {
        path: "international/new",
        async lazy() {
          const { InternationalRateCardPage } =
            await import("./international-rate-card-page");
          return { Component: InternationalRateCardPage };
        },
      },
      {
        path: "international/:cardId",
        async lazy() {
          const { InternationalRateCardPage } =
            await import("./international-rate-card-page");
          return { Component: InternationalRateCardPage };
        },
      },
    ],
  },
];
